<app-modal-title>{{getTitle()}}</app-modal-title>
<app-modal-body >
    <div [ngStyle]="{'height': height}">
        <app-datatable [identifier]="'activities-systems-details-table'" [cols]="taskCol" [rows]="taskRow"></app-datatable>
    </div>
</app-modal-body>
<app-modal-footer>
    <button class="ot-btn ot-btn--is-primary" i18n-title title="Close" (click)="close()" i18n>
        Close
    </button>
</app-modal-footer>